<template>
  <div>
    <div class="sayfahead">
      <h1>{{SayfaAdi}}</h1>
      <el-button-group class="float-right">
        <el-button type="info" size="small" v-if="Yetki && Bilgi.bBilgi!='Aidatım'" class="YeniBtn" @click="DuzenleBtn">
          Düzenle
        </el-button>
      </el-button-group>
    </div>
    <div class="icerik">
      <el-row :gutter="24">
        <el-col :span="20">
          <el-table
            class="table-xs"
            style="width: 100%"
            width="100%"
            v-if="Dosyalar"
            :data="Dosyalar"
            :height="Height"
          >
            <el-table-column
              label="Dosya Tarihi"
              prop="Tarih"
              width="100">
            </el-table-column>
            <el-table-column
              label="Dosya No"
              prop="dNo"
              width="130">
            </el-table-column>
            <el-table-column
              label="Bina"
              prop="Adi"
              width="150">
            </el-table-column>
            <el-table-column
              label="Borçlu Bilgi"
              prop="Bilgi">
            </el-table-column>

          </el-table>
        </el-col>
        <el-col :span="4">
          <div class="BlokSabit" style="height: 80vh !important;">
            <div class="BlokSabitKutu">
              <BilgiKutu :data="BilgiKutu"></BilgiKutu>
              <Notlar :data="Notlar"></Notlar>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <FormModal :data="Bilgi" v-if="ModalOlayi" :ModalOlayi="ModalOlayi" :Baslik="Baslik"
               @ModalOlayi="SayfaYukle"></FormModal>
  </div>

</template>

<script>

  import Notlar from "../../../components/Pack/Genel/Notlar";
  import BilgiKutu from "../../../components/Pack/Genel/BilgiKutu";
  import FormModal from "../../../components/Pack/Muhasebe/cari/FormModal";

  export default {
    components: {FormModal, BilgiKutu, Notlar},

    data() {
      return {
        Height: 0,
        Yetki: false,
        ModalOlayi: false,
        SayfaAdi: null,
        Dosyalar: null,
        Baslik: null,
        Bilgi: [],
        Notlar: {
          Modul: 'Cari',
          Modul_id: this.$route.params.Avukat_id
        }
      }
    },
    methods: {
      DuzenleBtn() {
        this.Baslik = this.Bilgi.Unvan + ' Düzenle';
        this.ModalOlayi = true
      },
      SayfaYukle() {
        this.ModalOlayi = false
        /* SADECE BİNA BİLGİSİ ALINIYOR */
        this.$store.dispatch("Get", {path: 'muhasebe/cari/d/' + this.$route.params.Avukat_id})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Yenile = false;
              this.Bilgi = response.Bilgi;
              this.Dosyalar = response.Dosyalar;
              this.Height = '80vh';
              this.SayfaAdi = response.Bilgi.Unvan;
              this.Notlar.Modul_id = this.Bilgi.id;
              this.BilgiKutu = {
                Baslik: 'Cari Bilgi',
                Detay: [
                  {Baslik: 'Ticari Ünvan', Bilgi: this.Bilgi.Unvan, Ikon: 'flaticon-background'},
                  {Baslik: 'Vergi Dairesi', Bilgi: this.Bilgi.vDairesi, Ikon: 'flaticon-background'},
                  {Baslik: 'Vergi No', Bilgi: this.Bilgi.vNo, Ikon: 'flaticon-background'},
                  {Baslik: 'Telefon', Bilgi: this.Bilgi.Telefon, Ikon: 'flaticon-background'},
                  {Baslik: 'Mail', Bilgi: this.Bilgi.Mail, Ikon: 'flaticon-background'},
                  {Baslik: 'Adres', Bilgi: this.Bilgi.Adres, Ikon: 'flaticon-background'},
                  {Baslik: 'Banka Adı', Bilgi: this.Bilgi.bBilgi.Adi, Ikon: 'flaticon-background'},
                  {Baslik: 'IBAN', Bilgi: this.Bilgi.bBilgi.Iban, Ikon: 'flaticon-background'},
                ]
              };
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          })

      }
    },
    created() {
      this.SayfaYukle();
      this.Yetki = this.$store.getters.Yetki.icra == '2' ? true : false;
    },

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Icra/avukat/detay.vue